$( ( $ ) => {
  const blogInnerContentSection = $(
    '.bs-section--blog-inner-content'
  );
  if ( blogInnerContentSection.length > 0 ) {
    const legacyTable = blogInnerContentSection.find(
      '.bs-row > .bs-column > table'
    );

    if ( legacyTable.length>0 ) {
      legacyTable.each( ( index, element ) => {
        let singleRowClass = '';
        if ( $( element ).find( 'tbody tr' ).length==1 ) {
          singleRowClass = 'single-row-table';
        }
        $( element ).wrap( '<div class="bs-div bs-div---default bs-div--standard-blog-inner-table">' +
          '<div class="bs-div__inner">' +
          '<figure class="wp-block-table '+singleRowClass+'"></figure></div></div>' );
      } );
    }
  }
} );
